import Mixin from '../Mixin';
import FDictionaryRoomAccommodation from '@/modules/Dictionary/RoomAccommodation/Select';
import FDictionaryBoarding from '@/modules/Dictionary/Boarding/Select';
import FDictionaryShip from '@/modules/Dictionary/Ship/Select';
import FDictionaryCabin from '@/modules/Dictionary/Cabin/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  ship = new FDictionaryShip({
    label: 'Лайнер',
    required: true,
  });

  cabin = new FDictionaryCabin({
    label: 'Тип каюты',
  });

  roomAccommodation = new FDictionaryRoomAccommodation({
    label: 'Тип размещения',
  });

  boarding = new FDictionaryBoarding({
    label: 'Тип питания',
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['ship', this.ship],
      ['cabin', this.cabin],
      ['roomAccommodation', this.roomAccommodation],
      ['boarding', this.boarding],
    ]);
    this.service.set({
      value: 7,
      label: 'Круиз',
    });
  }


  set(value = {}) {
    super.set(value);
    this.__set('ship', value.ship, null);
    this.__set('cabin', value.cabin, null);
    this.__set('roomAccommodation', value.roomAccommodation, null);
    this.__set('boarding', value.boarding, null);
    return this;
  }

  toString() {
    return this.ship.toString();
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = this.ship.toLabel();
        return data;
      });
  }
}
